import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMindset } from '../../mindset-agent/mindset-context'
import { NOTIFICATION_ACTION } from '../constants'

/**
 * Resolves a notification's `action` when it is clicked (see the rationale on
 * NOTIFICATION_ACTION in constants.js): pages get direct navigation, M:Coach
 * opens the Mindset agent in place, and page-less destinations open one of the
 * notification modals. Returns the modal state so the bell can render
 * <NotificationModals /> next to the panel.
 */
export const useNotificationAction = () => {
  const navigate = useNavigate()
  const { openMindset } = useMindset()
  const [activeModal, setActiveModal] = useState(null)

  const closeModal = useCallback(() => setActiveModal(null), [])

  const runAction = useCallback(action => {
    if (!action) return
    if (action.kind === NOTIFICATION_ACTION.NAVIGATE && action.to) {
      navigate(action.to)
    } else if (action.kind === NOTIFICATION_ACTION.MINDSET) {
      openMindset({ from: 'notification-centre' })
    } else if (action.kind === NOTIFICATION_ACTION.MODAL && action.modal) {
      setActiveModal(action.modal)
    }
  }, [navigate, openMindset])

  return { activeModal, closeModal, runAction }
}

export default useNotificationAction
